<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  data1ls: Array,
  dataJds: Array,
  dataNonJds: Array,
  categories: Array,
  year1: Number,
  year2: Number,
})

const plotBand = { color: "rgba(68, 170, 213, 0.1)", label: { style: { color: "#606060" } } }

// https://en.wikipedia.org/wiki/List_of_recessions_in_the_United_States
const recessions = [
  [1969, 1970],
  [1973, 1975],
  [1980, 1980.5],
  [1981.5, 1982.9],
  [1990, 1991],
  [2001.25, 2001.9],
  [2007, 2009],
]

onMounted(() => {
  const { data1ls, dataJds, dataNonJds, categories, year1: min, year2: max } = props

  const xAxis = {
    categories,
    endOnTick: true,
    min,
    max,
    // List of US recessions
    plotBands: recessions.map(([start, end]) => ({
      from: start,
      to: end,
      ...plotBand,
    })),
  }

  new Highcharts.Chart({
    chart: { renderTo: "EnrlGraph", zoomType: "xy" },
    title: { text: "Law School Enrollment" },
    legend: { enabled: false },
    subtitle: { text: "First-Year Students" },
    tooltip: { pointFormat: '<span style="color:{series.color}"></span>{series.name}: <b>{point.y}</b><br/>' },
    xAxis,
    yAxis: [
      { // total Students
        gridLineWidth: 1,
        title: { text: "# students", style: { color: "#4572A7" } },
        labels: { formatter() {
                    return `${this.value / 1000}k`
                  },
                  style: { color: "#4572A7" } },
        opposite: false,
        endOnTick: true,
        min: 10000,
        max: 55000,
      },
    ],
    series: [
      {
        name: "1L Enrollment",
        type: "spline",
        color: "#e8590c",
        marker: { enabled: false, symbol: "circle" },
        yAxis: 0,
        data: data1ls,
      }],
  })

  new Highcharts.Chart({
    chart: { renderTo: "EnrlGraph2", zoomType: "xy" },
    title: { text: "Law School Enrollment" },
    legend: { enabled: false },
    subtitle: { text: "JD Students, Non-JD Students" },
    tooltip: { pointFormat: '<span style="color:{series.color}"></span>{series.name}: <b>{point.y}</b><br/>' },
    xAxis,
    yAxis: [
      { // total Students
        gridLineWidth: 1,
        title: { text: "# students", style: { color: "#4572A7" } },
        labels: { formatter() {
                    return `${this.value / 1000}k`
                  },
                  style: { color: "#4572A7" } },
        opposite: false,
        endOnTick: true,
        min: 0,
        max: 150000,
        minorTickInterval: "auto",
      },
    ],
    series: [
      {
        name: "JD Enrollment",
        type: "spline",
        color: Highcharts.getOptions().colors[4],
        marker: { enabled: false, symbol: "circle" },
        yAxis: 0,
        data: dataJds,
      },
      {
        name: "Non-JD Enrollment",
        type: "spline",
        color: Highcharts.getOptions().colors[6],
        marker: { enabled: false, symbol: "circle" },
        yAxis: 0,
        data: dataNonJds,
      },
    ],
  })
})
</script>
